/** Transform a raw parsed response using the given maper */
export const paginatedResponse = (mapper) => (parsedPaginationResponse) => {
    return {
        count: parsedPaginationResponse.count,
        results: parsedPaginationResponse.results.map(mapper),
        next: parsedPaginationResponse.next,
        previous: parsedPaginationResponse.previous
    };
};
